export enum CdAStatus {
  alta = 'ALTA',
  bassa = 'BASSA',
  media = 'MEDIA',
  medioAlta = 'MEDIO-ALTA',
  medioBassa = 'MEDIO-BASSA',
}
